import { c as _c } from "react/compiler-runtime";
import { useHotelSortView } from "@website/accommodation-ui/hotel-list-header/hotel-sort-view/hotel-sort-view.hook";
import { HotelSortViewPropertiesType } from "@website/accommodation-ui/hotel-list-header/hotel-sort-view/hotel-sort-view.types";
import { Button } from "@website/ui/button";
import { MiniPopover } from "@website/ui/mini-popover";
import { Radio } from "@website/ui/radio";
import { FC } from "react";
export const HotelSortView: FC<HotelSortViewPropertiesType> = properties => {
  const $ = _c(19);
  const {
    buttonProps,
    popoverProps,
    radioProps
  } = useHotelSortView(properties);
  const t0 = `truncate ${buttonProps.className ?? ""}`;
  let t1;
  if ($[0] !== buttonProps || $[1] !== t0) {
    t1 = <Button {...buttonProps} className={t0} />;
    $[0] = buttonProps;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `${popoverProps.className} overflow-hidden`;
  let t3;
  if ($[3] !== radioProps.checkedRadio || $[4] !== radioProps.list || $[5] !== radioProps.onChangeRadio) {
    let t4;
    if ($[7] !== radioProps.checkedRadio || $[8] !== radioProps.onChangeRadio) {
      t4 = item => <Radio key={item.label} {...item} checked={radioProps.checkedRadio === item.value} className="my-3 text-sm" color="secondary" name="radiobutton" onChange={radioProps.onChangeRadio} />;
      $[7] = radioProps.checkedRadio;
      $[8] = radioProps.onChangeRadio;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = radioProps.list.map(t4);
    $[3] = radioProps.checkedRadio;
    $[4] = radioProps.list;
    $[5] = radioProps.onChangeRadio;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <div className="flex flex-1 flex-col overflow-hidden"><div className="flex flex-1 overflow-hidden px-3.5"><div>{t3}</div></div></div>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== popoverProps || $[13] !== t2 || $[14] !== t4) {
    t5 = <MiniPopover {...popoverProps} popoverClassName={t2}>{t4}</MiniPopover>;
    $[12] = popoverProps;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t1 || $[17] !== t5) {
    t6 = <div className="relative">{t1}{t5}</div>;
    $[16] = t1;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};